<template>
   <div class="key-plan">
      <router-link :to="link">
         <img :src="require(`../../../assets/icons/${icon}.svg`)" alt="product">
      </router-link>
      <router-link :to="link">{{title}}</router-link>
      <div class="cost-cell">
         <p>{{$t("pages.pricing.cart.start.cost")}}</p>
         <p class="cost">${{cost.toFixed(2)}}</p>
      </div>
      <p>
         <slot></slot>
      </p>
      <button class="buy-btn" v-on:click="addToCart">{{$t("pages.pricing.cart.buy")}}</button>
   </div>
</template>

<script>
    export default {
        name: "PricingKeyPlan",
        props: ['title', 'icon', 'cost', 'alternative', 'productId', 'link'],
        methods: {
            addToCart() {
                console.info(`add to cart: ${this.productId}, 1`);
                this.$store.commit('addToCart', {product: this.productId, qty: 1});
            }
        }
    }
</script>

<style scoped lang="scss">
   @import "../../../theme/theme";

   .key-plan {
      display: grid;
      grid-template-columns: auto;
      grid-template-rows: auto 3rem auto auto 1fr auto;
      justify-items: legacy;
      align-items: center;
      height: 100%;

      .buy-btn {
         align-self: end;
         //margin-bottom: 1em;
      }

      h3 {
         justify-self: center;
         font-size: 1.5rem;
         font-weight: normal;
         color: $text80;
      }
   }


   .cost-cell {
      display: flex;
      color: $text60;
      align-items: baseline;
      font-size: 1em;
      justify-content: center;
   }

   .cost-cell p {
      text-align: center;
      margin-top: 1em;
      justify-self: baseline;
      //margin-left: 1em;
      //margin-right: 0.5rem;
   }

   .cost-cell .cost {
      font-size: 1.5em;
      color: $text100;
      margin-left: 1em;
   }

   .key-plan > p {
      margin-top: 1rem;
      margin-left: 1rem;
      margin-right: 1rem;
      margin-bottom: 0.5rem;
      justify-self: center;
      font-size: 1em;
      text-align: justify;
      color: $text100;
   }

   a.img {
      width: auto;
      height: auto;
      max-height: 16rem;
   }

   @media (min-width: 20rem) and (max-width: 60rem) {
      .img {
         max-height: 8rem;
      }
   }

   @media (max-width: 20rem) {
      .img {
         max-height: 6rem;
      }
   }

   a img:hover {
      opacity: 0.7;
   }

   a {
      text-decoration: none;
      text-effect: none;
      font-size: 1.3em;
      color: $primary20;
      text-align: center;
      margin-left: 1rem;
      margin-right: 1rem;
   }

   a:hover {
      color: $primary80;
   }

   button {
      grid-row: 6;
      grid-column: 1;
      margin-top: 1em;
      padding: 0.7em 3em;
      background: $primary10;
      border: 0;
      text-decoration: none;
      text-effect: none;
      font-size: 1em;
      cursor: pointer;
      color: $primaryText100;
      transition: all .25s;
      outline: none;
   }

   button:hover {
      background: $primary40;
   }


</style>